import { Dialog } from '@headlessui/react';
import { XIcon } from '@heroicons/react/outline';
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Logo } from './Logo';
import { SideNavigation } from './SideNavigation';
import PropTypes from 'prop-types';

export const MobileSidebar = ({ sidebarOpen, setSidebarOpen }) => {
  return (
    <AnimatePresence>
      {sidebarOpen && (
        <Dialog
          as="div"
          className="fixed inset-0 z-[999] md:hidden"
          open={sidebarOpen}
          onClose={setSidebarOpen}
        >
          {/* Background Overlay */}
          <motion.div
            className="fixed inset-0 bg-black/40 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />

          {/* Sidebar Panel */}
          <div className="fixed inset-y-0 left-0 w-full max-w-xs flex">
            <motion.div
              initial={{ x: '-100%' }}
              animate={{ x: 0 }}
              exit={{ x: '-100%' }}
              transition={{ type: 'tween', duration: 0.3 }}
              className="relative flex flex-col w-full h-full bg-[#26232d] shadow-xl "
            >
              {/* Header with Close */}
              <div className="flex items-center justify-between px-4 py-4 border-b border-gray-700">
                <Logo />

                <button
                  onClick={() => setSidebarOpen(false)}
                  className="p-2 rounded-lg hover:bg-gray-100 active:scale-95 transition"
                >
                  <XIcon className="h-6 w-6 text-gray-700" />
                </button>
              </div>

              {/* Navigation */}
              <div className="flex-1 overflow-y-auto p-4">
                <SideNavigation showLabels={true} onLinkClick={() => setSidebarOpen(false)} />
              </div>
            </motion.div>
          </div>
        </Dialog>
      )}
    </AnimatePresence>
  );
};

MobileSidebar.propTypes = {
  sidebarOpen: PropTypes.bool.isRequired,
  setSidebarOpen: PropTypes.func.isRequired,
};
